import { useCallback } from "react";

/**
 * Sets document.title to the given fileName before printing (so browsers
 * default the "Save as PDF" filename to it), then restores the original
 * title after printing finishes.
 *
 * @param {string} fileName - desired filename (without extension), e.g. quoteReference
 * @returns {Function} handlePrint - call this from your button's onClick
 */
const usePrintWithFilename = (fileName) => {
    const handlePrint = useCallback(() => {
        if (!fileName) {
            alert("Details are still loading. Please wait a moment and try again.");
            return;
        }

        const originalTitle = document.title;
        const safeFileName = fileName.replace(/[\/\\:*?"<>|]/g, "-");

        document.title = safeFileName;

        const restoreTitle = () => {
            document.title = originalTitle;
            window.removeEventListener("afterprint", restoreTitle);
        };
        window.addEventListener("afterprint", restoreTitle);

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                window.print();
            });
        });
    }, [fileName]);

    return handlePrint;
};

export default usePrintWithFilename;